import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const MappingSourceQLTSDetail = defineAsyncComponent(() => import('@/views/faVoucherQLTS/MappingSourceQLTSDetail.vue'));

const popupFAVoucherIncreament = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherIncreament/FAVoucherIncreament.vue'),
);

const popupFAVoucherIncreamentDetail = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherIncreament/FAVoucherIncreamentDetail.vue'),
);

const popupFAVoucherIncreamentDetailFixedAsset = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/fixedAsset/faVoucherIncreament/FAVoucherIncreamentDetail.vue'),
);

const popupFAVoucherDecrementDetailFixedAsset = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/fixedAsset/faVoucherDecrement/FAVoucherDecrementDetail.vue'),
);

const popupFAVoucherAdjustmentDetailFixedAsset = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/fixedAsset/faVoucherAdjustment/FAVoucherAdjustmentDetail.vue'),
);

const popupFAVoucherDepreciationDetailFixedAsset = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/fixedAsset/faVoucherDepreciation/FAVoucherDepreciationDetail.vue'),
);

const popupFAVoucherDecrement = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherDecrement/FAVoucherDecrement.vue'),
);

const popupFAVoucherDecrementDetail = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherDecrement/FAVoucherDecrementDetail.vue'),
);

const popupFAVoucherDepreciation = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherDepreciation/FAVoucherDepreciation.vue'),
);

const popupFAVoucherDepreciationDetail = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherDepreciation/FAVoucherDepreciationDetail.vue'),
);

const popupFAVoucherAdjustment = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherAdjustment/FAVoucherAdjustment.vue'),
);

const popupFAVoucherAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/faVoucherAdjustment/FAVoucherAdjustmentDetail.vue'),
);

// List
const FAVoucherListTab = defineAsyncComponent(() => import('@/views/faVoucherQLTS/faVoucherList/FAVoucherList.vue'));
const FixedAssetVoucherListTab = defineAsyncComponent(() =>
  import('@/views/faVoucherQLTS/fixedAsset/FixedAssetVoucherList.vue'),
);

export function registerFAVoucher(app) {
  const registerConfig = {
    MappingSourceQLTSDetail: MappingSourceQLTSDetail,
    FAVoucherIncreament: popupFAVoucherIncreament,
    FAVoucherIncreamentDetail: popupFAVoucherIncreamentDetail,
    FAVoucherIncreamentDetailFixedAsset: popupFAVoucherIncreamentDetailFixedAsset,
    FAVoucherDecrementDetailFixedAsset: popupFAVoucherDecrementDetailFixedAsset,
    FAVoucherAdjustmentDetailFixedAsset: popupFAVoucherAdjustmentDetailFixedAsset,
    FAVoucherDepreciationDetailFixedAsset: popupFAVoucherDepreciationDetailFixedAsset,
    FAVoucherDecrement: popupFAVoucherDecrement,
    FAVoucherDecrementDetail: popupFAVoucherDecrementDetail,
    FAVoucherDepreciation: popupFAVoucherDepreciation,
    FAVoucherDepreciationDetail: popupFAVoucherDepreciationDetail,
    FAVoucherAdjustment: popupFAVoucherAdjustment,
    FAVoucherAdjustmentDetail: popupFAVoucherAdjustmentDetail,
    // List
    FAVoucherListTab: FAVoucherListTab,
    FixedAssetVoucherListTab: FixedAssetVoucherListTab,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'FAVoucherQlts');
}
